var _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ParrotSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#4dd0e1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#212121",
    points: "30.252,38.194 21.909,23.131 25.497,18.651 38.914,13.097 25.497,13.394 34.229,8.8 17.634,11.406 16.263,18.171 9.566,18.606 8.4,24.343 11.76,21.6 22.206,32.069 30.434,41.28 27.692,35.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ParrotSecurity);
export default __webpack_public_path__ + "static/media/icons8-parrot-security.402c719199a8b411af9e0bf5272c464f.svg";
export { ForwardRef as ReactComponent };